import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Wraper from "../Components/Dashboard/Wraper/Wraper";
import Dashboard from "../layout/Sub_Admin/Dashboard/Dashboard";
import Profile from "../layout/Sub_Admin/Profile/Profile";
import AllClients from "../layout/Sub_Admin/ClientList/ClientList";
import AddClients from "../layout/Sub_Admin/ClientList/Add_Client";
import EditClients from "../layout/Sub_Admin/ClientList/Edit_Client";
import Signals from "../layout/Sub_Admin/Signals/Signals";

import TradingStatus from "../layout/Sub_Admin/Tradingstatus/Tradingstatus";
import HelpCenter from "../layout/Sub_Admin/HelpCenter/HelpCenter";
import ApiCreateInfo1 from "../layout/Sub_Admin/ApiCreateInfo/ApiCreateInfo.jsx";

import Faq from "../layout/Admin/Faq/Faq.jsx";
import TradeHistory from "../layout/Sub_Admin/TradeHistory/TradeHistory";
import AllStrategy from "../layout/Sub_Admin/Service/AllStrategy/AllStrategy";
import AddStraegyNormal from "../layout/Sub_Admin/Service/AllStrategy/AddStraegyNormal";
import EditStrategyNormal from "../layout/Sub_Admin/Service/AllStrategy/EditStrategyNormal.jsx";
import GroupService from "../layout/Sub_Admin/Service/GroupService/GroupService";
import AddGroup from "../layout/Sub_Admin/Service/GroupService/Add_Group";
import EditGroup from "../layout/Sub_Admin/Service/GroupService/Edit_Group";

import Closeposition from "../layout/Sub_Admin/Signals/TradeHistory/closeposition.jsx";
import Openposition from "../layout/Sub_Admin/Signals/TradeHistory/openposition.jsx";
import CoinDCXGuide from "../layout/Sub_Admin/ApiCreateInfo/CoinDCXGuide.jsx";
import Pi42 from "../layout/Sub_Admin/ApiCreateInfo/Pi42.jsx";
import BinanceGuide from "../layout/Sub_Admin/ApiCreateInfo/Binance.jsx";
import Deltaexchange from "../layout/Sub_Admin/ApiCreateInfo/Deltaexchange.jsx"
import CoinSwitch from "../layout/Sub_Admin/ApiCreateInfo/CoinSwitch.jsx"
import TradeHistorys from "../layout/Sub_Admin/Signals/TradeHistory/tradehistory.jsx";
import Trade from "../layout/Sub_Admin/Trade/Trade.jsx";

import TradeCcalculation from "../layout/Sub_Admin/Calculation/TradeCalculation.jsx";


const Admin = () => {

  const location = useLocation();

  return (
    <>
      {location.pathname !== "/subadmin" &&
        location.pathname !== "/subadmin/*" ? (
        <Wraper />
      ) : null}

      <Routes>
        {/* <> */}
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/clients" element={<AllClients />} />
        <Route exact path="/client/edit/:id" element={<EditClients />} />
        <Route exact path="/client/add" element={<AddClients />} />
        <Route exact path="/signals" element={<Signals />} />
        {/* <Route exact path="/tradehistory" element={<TradeHistory />} /> */}
        <Route exact path="/tradingstatus" element={<TradingStatus />} />
        <Route exact path="/apicreateinfo" element={<ApiCreateInfo1 />} />
        <Route exact path="/helpcenter" element={<HelpCenter />} />

        <Route exact path="/faq" element={<Faq />} />
        {/* <Route exact path="/TradeHistory" element={<TradeHistory />} /> */}

        <Route exact path="/strategies" element={<AllStrategy />} />
        <Route exact path="/strategies/add" element={<AddStraegyNormal />} />
        <Route
          exact
          path="/strategies/edit/:id"
          element={<EditStrategyNormal />}
        />


        <Route exact path="/groupservices" element={<GroupService />} />
        <Route exact path="/groupservices/add" element={<AddGroup />} />
        <Route exact path="/groupservices/edit/:id" element={<EditGroup />} />

        <Route exact path="/openposition" element={<Openposition />} />
        <Route exact path="/closeposition" element={<Closeposition />} />
        <Route exact path="/apicreateinfo/coindexguide" element={<CoinDCXGuide />} />
        <Route exact path="/apicreateinfo/binanceGuide" element={<BinanceGuide />} />
        <Route exact path="/apicreateinfo/deltaexchange" element={<Deltaexchange />} />
        <Route exact path="/apicreateinfo/coinswitch" element={<CoinSwitch />} />
        <Route exact path="/apicreateinfo/pifourtwo" element={<Pi42 />} />
        <Route exact path="/TradeHistory" element={<TradeHistorys />} />

        <Route exact path="/trade" element={<Trade />} />
        <Route exact path="/tradeCcalculation" element={<TradeCcalculation />} />


      </Routes>
    </>
  );
};

export default Admin;
